/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

/**
 *
 * @param {Element} inputNode
 * @param {Object} optionsP
 * @returns {DatePicker}
 */
function DatePicker(inputNode, optionsP) {
  "strict mode";

  if (!this instanceof DatePicker) return new DatePicker(inputNode);

  // ---- config ----
  var options = {
    lng: "de",
    years: {
      from: 1950,
      to: 2020,
    },
  };
  for (var i in optionsP) options[i] = optionsP[i];

  // ---- config end----

  var HTML =
    '<div class="header">' +
    "<h2></h2>" +
    "<h1></h1>" +
    "</div>" +
    '<div class="content">' +
    '<div class="years">' +
    '<div class="shaddow top"></div>' +
    "<ul></ul>" +
    '<div class="shaddow bottom"></div>' +
    "</div>" +
    '<div class="month-selector">' +
    '<i class="prev material-icons">navigate_before</i>' +
    '<div class="month"></div>' +
    '<i class="next material-icons">navigate_next</i>' +
    "</div>" +
    '<div class="months"></div>' +
    "</div>" +
    '<div class="actions">' +
    '<a class="cancel">' +
    lng().buttons.cancel +
    "</a>" +
    '<a class="ok">' +
    lng().buttons.ok +
    "</a>" +
    "</div>";

  var that = this;

  /**
   * @type Date
   */
  this._currentDate = null;

  /**
   * Contains pointer to the month nodes.
   * Structure is <i>_months[year<Number>][month<Number>].
   * @type Object
   */
  this._months = {
    /**
     * @type element
     */
    current: null,
  };

  // ---- create node ----
  this.node = document.createElement("div");
  this.node.classList.add("date-picker");
  this.node.insertAdjacentHTML("beforeend", HTML);

  inputNode.DatePicker = this;
  document.body.appendChild(this.node);
  // ---- create node end ----

  // ---- some pointer ----
  var nodes = {
    header: {
      /**
       * Node with year of selecton
       * @type Element
       */
      year: this.node.querySelector(".header h2"),
      /**
       * Node with a sumerize of selected date
       * @type Element
       */
      sum: this.node.querySelector(".header h1"),
    },
    monthSelector: {
      /**
       * @type element
       */
      prev: this.node.querySelector(".month-selector i.prev"),
      /**
       * @type element
       */
      month: this.node.querySelector(".month-selector .month"),
      /**
       * @type element
       */
      next: this.node.querySelector(".month-selector i.next"),
    },
    /**
     * @type element
     */
    months: this.node.querySelector(".months"),
    /**
     * @type element
     */
    years: this.node.querySelector(".years ul"),
    actions: {
      /**
       * @type element
       */
      cancel: this.node.querySelector(".cancel"),
      /**
       * @type element
       */
      ok: this.node.querySelector(".ok"),
    },
  };
  // ---- some pointer end ----

  for (var i = options.years.from; i <= options.years.to; i++) {
    var year = document.createElement("li");
    year.textContent = i;
    year.addEventListener("click", function () {
      var newDate = new Date(that._currentDate);
      newDate.setFullYear(this.textContent);
      that.applyMonth(genMonth(newDate));

      nodes.header.year.classList.remove("on");
      nodes.years.parentNode.classList.remove("on");
    });
    nodes.years.appendChild(year);
  }

  // ---- listener ----
  inputNode.addEventListener("click", show);

  nodes.header.year.addEventListener("click", function () {
    this.classList.add("on");
    nodes.years.parentNode.classList.add("on");
  });
  nodes.header.sum.addEventListener("click", function () {
    nodes.header.year.classList.remove("on");
    nodes.years.parentNode.classList.remove("on");
  });

  nodes.monthSelector.prev.addEventListener("click", function () {
    var prevDate = new Date(that._months.current.date);
    prevDate.setMonth(prevDate.getMonth() - 1);
    that.applyMonth(genMonth(prevDate));
  });
  nodes.monthSelector.next.addEventListener("click", function () {
    var nextDate = new Date(that._months.current.date);
    nextDate.setMonth(nextDate.getMonth() + 1);
    that.applyMonth(genMonth(nextDate));
  });

  nodes.actions.cancel.addEventListener("click", hide);
  nodes.actions.ok.addEventListener("click", function () {
    var month = that._currentDate.getMonth() + 1;
    month = month < 10 ? "0" + month : month;
    var day = that._currentDate.getDate();
    day = day < 10 ? "0" + day : day;

    var dateStr = that._currentDate.getFullYear() + "-" + month + "-" + day;

    inputNode.value = dateStr;
    that.hide();
  });

  function position() {
    that.position();
  }
  window.addEventListener("orientationchange", position);
  window.addEventListener("resize", position);
  document.addEventListener("fullscreenchange", position);
  document.addEventListener("mozfullscreenchange", position);
  document.addEventListener("webkitfullscreenchange", position);
  document.body.addEventListener("scroll", position); //scroll event is maybe too expensive
  document.body.addEventListener("click", hide, true);
  // ---- listener end ----

  function show(e) {
    that.show();
    if (e) {
      e.preventDefault();
      e.target.blur();
    }
  }
  this.show = function () {
    that.position();
    //wait for end of position calculation
    setTimeout(function () {
      that.node.classList.add("on");
    }, 50);

    if (!inputNode.value) that.setDate(new Date());
    else that.setDate(new Date(inputNode.value));
  };

  function hide(e) {
    that.hide(e);
  }
  this.hide = function (e) {
    //check if called by an event
    if (e && e.type === "click" && e.target !== nodes.actions.cancel) {
      var node = e.target;
      var exec = true;
      while (node !== document.body) {
        if (node === that.node || node === inputNode) {
          exec = false;
          break;
        }
        node = node.parentNode;
      }
      if (!exec) return;
    }

    if (e && that.node.classList.contains("on")) {
      e.stopPropagation();
      e.stopImmediatePropagation();
    }

    that.node.classList.remove("on");

    if (inputNode.classList.contains("mdl-textfield__input") && inputNode.value)
      inputNode.parentNode.classList.add("is-dirty");
  };

  this.position = function () {
    that.node.classList.add("no-animation");
    that.node.classList.add("calculate-rect");
    var rect = that.node.getBoundingClientRect();
    that.node.classList.remove("calculate-rect");
    requestAnimationFrame(function () {
      that.node.classList.remove("no-animation");
    });

    var inputRect = inputNode.getBoundingClientRect();

    var xCenter = inputRect.left + inputRect.width / 2;

    var targetCoords = {
      top: inputRect.top,
      left: xCenter - rect.width / 2,
    };

    //check if node is outside the window
    var xOffset = rect.width + targetCoords.left - window.innerWidth;
    var yOffset = rect.height + targetCoords.top - window.innerHeight;
    if (xOffset > 0)
      targetCoords.left = Math.max(0, targetCoords.left - xOffset);
    if (yOffset > 0) targetCoords.top = Math.max(0, targetCoords.top - yOffset);

    //set position
    that.node.style.top = targetCoords.top + "px";
    that.node.style.left = targetCoords.left + "px";

    //set transform-origin to the center of input
    that.node.style.transformOrigin =
      rect.width / 2 + "px " + inputRect.height / 2 + "px";
  };

  /**
   *
   * @param {Date} date
   * @returns {undefined}
   */
  this.setDate = function (date) {
    date = new Date(date);
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);

    //no value set
    if (!that._currentDate) {
      var newMonth = genMonth(date);
      that.applyMonth(newMonth);
      selectInMonth(date, newMonth);
      return;
    }

    //day in same month
    if (
      that._currentDate.getMonth() === date.getMonth() &&
      that._currentDate.getFullYear() === date.getFullYear()
    ) {
      selectInMonth(date, that._months.current);
      return;
    }

    //day in other month
    var newMonth = genMonth(date);
    that.applyMonth(newMonth);
    selectInMonth(date, newMonth);

    /**
     *
     * @param {Date} date
     * @param {Element} month
     * @returns {undefined}
     */
    function selectInMonth(date, month) {
      var tds = month.querySelectorAll("td");
      var time = date.getTime();

      for (var i = 0, len = tds.length; i < len; i++) {
        var td = tds[i];
        if (td.time === time) {
          selectTd(td);
          break;
        }
      }
    }
  };

  this.applyLabels = function () {
    var date = that._currentDate;
    nodes.header.year.textContent = date.getFullYear();
    nodes.header.sum.textContent =
      lng().days_short[date.getDay()] +
      "., " +
      date.getDate() +
      ". " +
      lng().months_short[date.getMonth()];

    var oldLi = nodes.years.querySelector(".selected");
    if (oldLi) oldLi.classList.remove("selected");
    var yearLis = nodes.years.children;
    var fullYear = date.getFullYear();
    for (var i = 0, len = yearLis.length; i < len; i++) {
      var li = yearLis[i];
      if (parseInt(li.textContent, 10) === fullYear) {
        li.classList.add("selected");
        break;
      }
    }
  };

  /**
   * Show month node in calender and hide the current.
   * @param {Element} month
   * @returns {undefined}
   */
  this.applyMonth = function (month) {
    var currentMonth = that._months.current;
    if (currentMonth === month) return;

    that._months.current = month;

    nodes.monthSelector.month.textContent =
      lng().months[month.date.getMonth()] + " " + month.date.getFullYear();

    if (!currentMonth) {
      nodes.months.appendChild(month);
      that.position();
      return;
    }

    var toFuture = currentMonth.date < month.date;
    month.classList.add(toFuture ? "future" : "past");

    nodes.months.appendChild(month);

    //need some ms to wait for pre animation position
    setTimeout(function () {
      requestAnimationFrame(function () {
        month.classList.remove(toFuture ? "future" : "past");
        currentMonth.classList.add(toFuture ? "past" : "future");
      });
    }, 20);
  };

  this.destroy = function () {
    window.removeEventListener("orientationchange", position);
    window.removeEventListener("resize", position);
    document.removeEventListener("fullscreenchange", position);
    document.removeEventListener("mozfullscreenchange", position);
    document.removeEventListener("webkitfullscreenchange", position);
    document.body.removeEventListener("click", hide);

    inputNode.DatePicker = undefined;
    inputNode.removeEventListener("focus", show);

    that.node.parentNode.removeChild(that.node);
    for (var i in that) that[i] = undefined;
    that = undefined;
  };

  /**
   * Generates a node of a single month
   * @param {Date} date
   * Date with month to use
   * @returns {Element}
   */
  function genMonth(date) {
    date = new Date(date);

    // -- cache --
    var thisYear = date.getFullYear();
    var thisMonth = date.getMonth();

    var yearPointer = that._months[thisYear];
    if (yearPointer) {
      var monthPointer = yearPointer[thisMonth];
      if (monthPointer) return monthPointer;
    } else {
      that._months[thisYear] = {};
      yearPointer = that._months[thisYear];
    }

    //remove some months wich are not near the current date
    if (thisMonth > 3 && thisMonth < 10) {
      remove(that._months[thisYear + 1]);
      remove(that._months[thisYear - 1]);
      that._months[thisYear + 1] = undefined;
      that._months[thisYear - 1] = undefined;
    }
    function remove(months) {
      if (!months) return;
      for (var i in months) {
        var month = months[i];
        month.parentNode.removeChild(month);
      }
    }
    // -- cache end --

    var dateForCalc = new Date(date);
    dateForCalc.setDate(1);
    dateForCalc.setHours(0);
    dateForCalc.setMinutes(0);
    dateForCalc.setSeconds(0);
    dateForCalc.setMilliseconds(0);

    var node = document.createElement("div");
    node.classList.add("month");
    node.date = date;
    //add to cache
    yearPointer[thisMonth] = node;

    var table = document.createElement("table");
    node.appendChild(table);

    // - table head -
    var thead = document.createElement("thead");
    table.appendChild(thead);
    var day;
    for (var i = 1; i < 7; i++) {
      day = document.createElement("th");
      day.textContent = lng().days_short[i];
      thead.appendChild(day);
    }
    //sunday
    day = document.createElement("th");
    day.textContent = lng().days_short[0];
    thead.appendChild(day);
    // - table head end -

    var now = new Date();
    var tbody = document.createElement("tbody");
    table.appendChild(tbody);
    /**
     * Number of days in week before the first day in month.
     * @type Number
     */
    var daysToSkip = dateForCalc.getDay() - 1;
    daysToSkip = daysToSkip === -1 ? 6 : daysToSkip;
    var tr = document.createElement("tr");
    tbody.appendChild(tr);
    while (daysToSkip--) tr.appendChild(document.createElement("td"));

    var nTr = 1;
    var month = dateForCalc.getMonth();
    while (dateForCalc.getMonth() === month) {
      var dayDate = dateForCalc.getDate();

      //create a new table row on monday
      if (dateForCalc.getDay() === 1 && (nTr !== 1 || dayDate !== 1)) {
        tr = document.createElement("tr");
        tbody.appendChild(tr);
        nTr++;
      }

      //create week day
      var td = document.createElement("td");
      td.textContent = dayDate;
      td.time = dateForCalc.getTime();
      tr.appendChild(td);

      //today?
      if (
        dateForCalc.getDate() === now.getDate() &&
        dateForCalc.getMonth() === now.getMonth() &&
        dateForCalc.getFullYear() === now.getFullYear()
      )
        td.classList.add("today");

      //selected?
      if (
        that._currentDate &&
        dateForCalc.getDate() === that._currentDate.getDate() &&
        dateForCalc.getMonth() === that._currentDate.getMonth() &&
        dateForCalc.getFullYear() === that._currentDate.getFullYear()
      )
        td.classList.add("selected");

      //click listener
      td.addEventListener("click", function () {
        selectTd(this);
      });

      //if the next day is in next month, month will be corrected by the native API
      dateForCalc.setDate(dayDate + 1);
    }
    //make sure the calender has always 6 rows
    while (nTr++ < 6) {
      tr = document.createElement("tr");
      td = document.createElement("td");
      td.classList.add("empty");
      td.textContent = ".";
      tr.appendChild(td);
      tbody.appendChild(tr);
    }

    return node;
  }

  function selectTd(td) {
    var oldTd = that.node.querySelector(".month td.selected");
    if (oldTd) oldTd.classList.remove("selected");
    td.classList.add("selected");

    that._currentDate = new Date(td.time);
    that.applyLabels();
  }

  // -------------- end of logic ---------------

  function lng() {
    var LANG = {
      de: {
        buttons: {
          cancel: "Abbrechen",
          ok: "Ok",
        },
        days: {
          0: "Sonntag",
          1: "Montag",
          2: "Dienstag",
          3: "Mittwoch",
          4: "Donnerstag",
          5: "Freitag",
          6: "Samstag",
        },
        days_short: {
          0: "So",
          1: "Mo",
          2: "Di",
          3: "Mi",
          4: "Do",
          5: "Fr",
          6: "Sa",
        },
        months: {
          0: "Januar",
          1: "Februar",
          2: "März",
          3: "April",
          4: "Mai",
          5: "Juni",
          6: "Juli",
          7: "August",
          8: "September",
          9: "Oktober",
          10: "November",
          11: "Dezember",
        },
        months_short: {
          0: "Jan",
          1: "Feb",
          2: "Mär",
          3: "Apr",
          4: "Mai",
          5: "Jun",
          6: "Jul",
          7: "Aug",
          8: "Sep",
          9: "Okt",
          10: "Nov",
          11: "Dez",
        },
      },
    };
    return LANG[options.lng];
  }
}
